import React from "react";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { H3 } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
var NoCompanyBenefits = function (props) {
    var onAdd = props.onAdd;
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", height: "60px" },
            React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsList.minimalView.title" })),
            React.createElement(Button, { primary: true, onClick: onAdd },
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsList.styledNameCountAndButton.buttonText" }))),
        React.createElement(Flex, { margin: "20px 0 0" },
            React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsList.emptyText" }))));
};
export default NoCompanyBenefits;
